import EventInfoPlace from './EventInfoPlace';
import EventInfoDates from './EventInfoDates';
import EventInfoWebsite from './EventInfoWebsite';

export default function EventPanelInfo({
  info,
}) {
  const hasPlace = info?.place !== null;
  const hasDates = info?.dates !== null;
  const hasWebsite = info?.website !== null;
  const hasContent = hasPlace || hasDates || hasWebsite;

  if (hasContent === false) {
    return null;
  }

  return (
    <div className="rounded shadow-xl bg-gray-900 text-gray-100 p-6 space-y-6">
      {hasPlace && (<EventInfoPlace place={info.place} />)}
      {hasDates && (<EventInfoDates dates={info.dates} />)}
      {hasWebsite && (<EventInfoWebsite website={info.website} />)}
    </div>
  );
}
